import { render, staticRenderFns } from "./AddDirection.vue?vue&type=template&id=0d5a89b1"
import script from "./AddDirection.vue?vue&type=script&lang=js"
export * from "./AddDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports